var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.model.image,"alt":_vm.model.imageAlt,"title":_vm.model.imageTitle}})])}
var staticRenderFns = []

export { render, staticRenderFns }